function diffDays(dateFrom, dateTo) {
  const diffTime = Math.abs(dateTo - dateFrom)
  const days = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  return days
}

export default diffDays
